import {
  Button,
  Flex,
  Form,
  Input,
  Row,
  Col,
  Select,
  Spin,
  message,
} from "antd";
import { useEffect, useState } from "react";
import { fetchComportConfigurationForFilter } from "../../ComportConfiguration/Service/comportConfiguration";

const DeviceTypeForm = (props) => {
  const [form] = Form.useForm();
  const [comportList, setComportList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (props.editData) {
      form.setFieldsValue({
        deviceType: props.editData.deviceType,
      });
    } else {
      form.resetFields();
    }
  }, [props.editData, form]);

  useEffect(() => {
    const fetchPorts = async () => {
      setIsLoading(true);
      try {
        const res = await fetchComportConfigurationForFilter();
        setComportList(res.data);
      } catch (err) {
        messageApi.open({
          type: "error",
          content: "Network error while fetching device type",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchPorts();
  }, []);

  const handleFinish = (data) => {
    return props.saveData(data).then((success) => {
      if (success) {
        form.resetFields();
      }
    });
  };

  return (
    <Spin spinning={isLoading}>
      {contextHolder}
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Device Type"
              name="deviceType"
              rules={[
                { required: true, message: "Please input device type name!" },
              ]}
            >
              <Input placeholder="Ex: Mahr MarCator 1086WRi" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Port"
              name={["serialConfig", "uuid"]}
              // rules={[{ required: true, message: "Please select comport!" }]}
            >
              <Select
                placeholder="Ex: COM3"
                options={comportList.map((e) => ({
                  label: e.port,
                  value: e.uuid,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* ================= ACTION ================= */}
        <Flex justify="end" style={{ marginTop: 24 }}>
          <Button type="primary" size="large" htmlType="submit">
            {props.editData ? "Update " : "Save "}Configuration
          </Button>
        </Flex>
      </Form>
    </Spin>
  );
};

export default DeviceTypeForm;
